$(document).ready(function(){



$('.bxslider1').bxSlider({

		// GENERAL
		mode: 'horizontal',
		slideSelector: '',
		infiniteLoop: true,
		hideControlOnEnd: false,
		speed: 700,
		easing: null,
		slideMargin: 0,
		startSlide: 0,
		randomStart: false,
		captions: false,
		ticker: false,
		tickerHover: false,
		adaptiveHeight: false,
		adaptiveHeightSpeed: 500,
		video: false,
		useCSS: true,
		preloadImages: 'visible',
		responsive: true,
		slideZIndex: 50,
		wrapperClass: 'bx-wrapper',

		// TOUCH
		touchEnabled: true,
		swipeThreshold: 50,
		oneToOneTouch: true,
		preventDefaultSwipeX: true,
		preventDefaultSwipeY: false,

		// PAGER
		pager: true,
		pagerType: 'full',
		pagerShortSeparator: ' / ',
		pagerSelector: null,
		buildPager: null,
		pagerCustom: null,

		// CONTROLS
		controls: false,
		nextText: 'Next',
		prevText: 'Prev',
		nextSelector: null,
		prevSelector: null,
		autoControls: false,
		startText: 'Start',
		stopText: 'Stop',
		autoControlsCombine: false,
		autoControlsSelector: null,

		// AUTO
		auto: true,
		pause: 4000,
		autoStart: true,
		autoDirection: 'next',
		autoHover: false,
		autoDelay: 0,
		autoSlideForOnePage: false,

		// CAROUSEL
		minSlides: 1,
		maxSlides: 1,
		moveSlides: 0,
		slideWidth: 0,

	});


$('.bxslider2').bxSlider({

		// GENERAL
		mode: 'horizontal',
		slideSelector: '',
		infiniteLoop: true,
		hideControlOnEnd: false,
		speed: 700,
		easing: null,
		slideMargin: 0,
		startSlide: 0,
		randomStart: false,
		captions: false,
		ticker: false,
		tickerHover: false,
		adaptiveHeight: false,
		adaptiveHeightSpeed: 500,
		video: false,
		useCSS: true,
		preloadImages: 'visible',
		responsive: true,
		slideZIndex: 50,
		wrapperClass: 'bx-wrapper',

		// TOUCH
		touchEnabled: true,
		swipeThreshold: 50,
		oneToOneTouch: true,
		preventDefaultSwipeX: true,
		preventDefaultSwipeY: false,

		// PAGER
		pager: true,
		pagerType: 'full',
		pagerShortSeparator: ' / ',
		pagerSelector: null,
		buildPager: null,
		pagerCustom: null,

		// CONTROLS
		controls: false,
		nextText: 'Next',
		prevText: 'Prev',
		nextSelector: null,
		prevSelector: null,
		autoControls: false,
		startText: 'Start',
		stopText: 'Stop',
		autoControlsCombine: false,
		autoControlsSelector: null,

		// AUTO
		auto: true,
		pause: 4000,
		autoStart: true,
		autoDirection: 'next',
		autoHover: false,
		autoDelay: 0,
		autoSlideForOnePage: false,

		// CAROUSEL
		minSlides: 1,
		maxSlides: 1,
		moveSlides: 0,
		slideWidth: 0,

	});


$('.bxslider4').bxSlider({

		// GENERAL
		mode: 'horizontal',
		slideSelector: '',
		infiniteLoop: true,
		hideControlOnEnd: false,
		speed: 300,
		easing: null,
		slideMargin: 0,
		startSlide: 0,
		randomStart: false,
		captions: false,
		ticker: false,
		tickerHover: false,
		adaptiveHeight: false,
		adaptiveHeightSpeed: 500,
		video: false,
		useCSS: true,
		preloadImages: 'visible',
		responsive: true,
		slideZIndex: 50,
		wrapperClass: 'bx-wrapper',

		// TOUCH
		touchEnabled: true,
		swipeThreshold: 50,
		oneToOneTouch: true,
		preventDefaultSwipeX: true,
		preventDefaultSwipeY: false,

		// PAGER
		pager: false,
		pagerType: 'full',
		pagerShortSeparator: ' / ',
		pagerSelector: null,
		buildPager: null,
		pagerCustom: null,

		// CONTROLS
		controls: true,
		nextText: '>',
		prevText: '<',
		nextSelector: '#calendario span.der',
		prevSelector: '#calendario span.izq',
		autoControls: false,
		startText: 'Start',
		stopText: 'Stop',
		autoControlsCombine: false,
		autoControlsSelector: null,

		// AUTO
		auto: false,
		pause: 4000,
		autoStart: true,
		autoDirection: 'next',
		autoHover: false,
		autoDelay: 0,
		autoSlideForOnePage: false,

		// CAROUSEL
		minSlides: 1,
		maxSlides: 1,
		moveSlides: 0,
		slideWidth: 0,

	});




	//-----------PORTADA----------------------

	$('#ico-menu').click(function(){
		
		$('#menu').addClass('open');
		$('.portada').addClass('open');
	});

	
	$('#cerr-menu').click(function(){
		
		$('#menu').removeClass('open');
		$('.portada').removeClass('open');
	});



	$('#menu ul li:first-child').click(function(){		
		
		$(this).addClass('menu-activo');
		$('#menu ul li:nth-child(2), #menu ul li:nth-child(3)').removeClass('menu-activo')	
		$('#productos').show().css('opacity', '1');
		$('#talleres, #contacto').css('opacity', '0');

	});
	$('#menu ul li:nth-child(2)').click(function(){		
		
		
		$('#menu ul li:nth-child(1), #menu ul li:nth-child(3)').removeClass('menu-activo')
		$(this).addClass('menu-activo');
		$('#productos, #contacto').hide().css('opacity', '0');
		$('#talleres').show().css('opacity', '1');


	});

	$('#menu ul li:nth-child(3)').click(function(){		
		
		
		$('#menu ul li:nth-child(1), #menu ul li:nth-child(2)').removeClass('menu-activo')
		$(this).addClass('menu-activo');
		$('#productos, #talleres').hide().css('opacity', '0');
		$('#contacto').show().css('opacity', '1');


	});

	$('#conoc-ir').click(function(){
	
$(window).scrollTo( '#conoc', 800 );

	return false;		
});


	//-----------MIS CUENTAS-------------------

	$('#a-perfil').click(function(){		
		
		$('#perfil').fadeIn();
		$('#ini-cuentas, #factura, #compras, footer').hide()
		$('#a-ini-cuentas, #a-factura, #a-compras').removeClass('menu-cuen-activo');
		$(this).addClass('menu-cuen-activo');
		return false;

	});
	$('#a-ini-cuentas').click(function(){		
		
		$('#ini-cuentas').fadeIn();
		$('#perfil, #factura, #compras, footer').hide()
		$('#a-perfil, #a-factura, #a-compras').removeClass('menu-cuen-activo');
		$(this).addClass('menu-cuen-activo');		
		$('footer').show();
		return false;

	});
	$('#a-factura').click(function(){		
		
		$('#factura').fadeIn();
		$('#perfil, #ini-cuentas, #compras, footer').hide()
		$('#a-perfil, #a-ini-cuentas, #a-compras').removeClass('menu-cuen-activo');
		$(this).addClass('menu-cuen-activo');
		return false;

	});
	$('#a-compras').click(function(){		
		
		$('#compras').fadeIn();
		$('#perfil, #ini-cuentas, #factura, footer').hide()
		$('#a-perfil, #a-ini-cuentas, #a-factura').removeClass('menu-cuen-activo');
		$(this).addClass('menu-cuen-activo');
		return false;

	});
	$('#masper').click(function(){	
		$('.none').fadeIn();


	});



});

$(window).load(function(){
	$('#registro2 img').removeClass('izq');

setTimeout(function() 
  {
	$('#registro3 img').removeClass('abaj');}, 1000 );


setTimeout(function() 
  {
$('#registro2 p').addClass('opa1')}, 2500);


setTimeout(function() 
  {
$('#registro2 img').removeClass('izq').addClass('derch')}, 4000);





});